const actions = {
  SET_STATE: 'expenses/SET_STATE',
  GET_DATA: 'expenses/GET_DATA',
  EDIT_EXPENSE: 'expenses/EDIT_EXPENSE',
  CREATE_EXPENSE: 'expenses/CREATE_EXPENSE',
  UPDATE_EXPENSES_LIST: 'expenses/UPDATE_EXPENSES_LIST',
  APPEND_EXPENSES_LIST: 'expenses/APPEND_EXPENSES_LIST',

  GET_EXPENSES: 'expenses/GET_EXPENSES',
  PAGE_CHANGED: 'expenses/PAGE_CHANGED',
  ROWS_CHANGED: 'expenses/ROWS_CHANGED',
}

export default actions
